'use client';

import { useEffect } from 'react';

export default function PersistGeoLocationInCookie() {
  useEffect(() => {
    (async () => {
      try {
        const response = await fetch('/api/geolocation', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }
      } catch (e) {
        console.info('fetching geolocation failed', e);
      }
    })();
  }, []);
  return null;
}
